<template>
  <el-container class="index">
    <!-- 头部 -->
    <!-- :style="{ height: nowHeight }" -->
    <el-aside width="200px" style="height:850px" class="aside">
      <img style="width: 100px; height: 100px" src="../../assets/app_img/newlog.png" alt="" />
      <ul>
        <el-menu :default-active="onRoutes" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose">
          <el-menu-item v-for="(item, index) in listArr" :key="index" :index="item.path" @click="toMenu(item)">
            <span slot="title">{{ item.name }}</span>

          </el-menu-item>
        </el-menu>
      </ul>
    </el-aside>
    <el-container>
      <el-header style="height: 80px !important">
        <div class="zong">
          <div class="titles">云平台</div>
          <div class="qiehuanClass">
            {{ classInfo && classInfo.name ? classInfo.name : '' }}
            <!-- {{ this.course_name}} -->
            {{ returnCourseName() }}
            <img @click="cut_class" src="../../assets/app_img/btn_change.png" alt="" />

          </div>
          <!-- <div class="lasts"> -->
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link" style="color: #1b2422">
              <img :src="photo" alt="" />
              {{ username }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="modify">修改密码</el-dropdown-item>
              <el-dropdown-item command="exit">退出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <!-- </div> -->
        </div>
      </el-header>
      <el-main style="background: #f6f8f9">
        <keep-alive include="Housework">
          <router-view :key="$route.fullPath" />
        </keep-alive>
      </el-main>
      <!-- 底部版本号 -->
      <el-footer class="version-footer">
        版本{{ versions.version_number }}&emsp;©深圳睿尚教育科技有限公司
      </el-footer>
    </el-container>
    <!-- dialog -->
    <Cutdialog ref="cutdialog" @changes="dialogs"></Cutdialog>
    <change-password v-if="isChangePassword" :isChangePassword="isChangePassword" @closePass="closePass"
      @savePass="savePass" />
  </el-container>
</template>

<script>
import Cutdialog from "./cutDialog.vue"
import { mapState } from 'vuex'
import ChangePassword from "../component/password/ChangePassword.vue"
export default {
  components: { Cutdialog, ChangePassword },
  data () {
    return {
      base_list: '',
      exitFlag: false,
      flag: false,
      menuId: "",
      listArr: [
        { name: "板书", path: "/banshu", listRef: "banshu", id: "1" },
        { name: "微课", path: "/weike", listRef: "weike", id: "2" },
        { name: "批注", path: "/pizhu", listRef: "pizhu", id: "3" },
        { name: "课件", path: "/kejian", listRef: "kejian", id: "4" },
        { name: "作业", path: "/housework", listRef: "kejian", id: "7" },
        { name: "班级", path: "/banji", listRef: "banji", id: "5" },
        { name: "操作手册", path: "/shouce", listRef: "shouce", id: "6" },
      ],
      listRoute: [],
      activeIndex: "1",
      nowHeight: "",
      versions: {}, // 版本信息
      isChangePassword: false,
      // lesson:localStorage.getItem('course_name'),
      // classname:localStorage.getItem('class_name')
    }
  },
  watch: {
    menuId: {
      handler (val, oldval) {
        this.menuId = val
      },
    },
  },


  computed: {
    ...mapState({
      lesson: state => state.lesson,
      classname: state => state.classname,
      classInfo: state => state.classInfo
    }),

    onRoutes () {
      const route = this.$route
      const { meta, path } = route
      // 在路由配置文件中设置自定义的路由路径到meta.activeMenu属性中，来控制菜单自定义高亮显示
      // meta中 有activeMenu 字段的子页面，都会显示高亮
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
  },

  created () {

    this.baseData()
    this.getUrl()
    this.getNowHeight()
    // 获取版本信息
    this.getSystemInfo()
    this.$store.dispatch('getLesson', 0)
  },
  mounted () {
    this.cutClassData()
    // 获取班级信息
    this.$store.dispatch('getClassInfo', localStorage.getItem('class_id'))
  },

  methods: {
    dialogs (item) {
      this.$forceUpdate()
      this.course_name = item.course_name
    },
    async cutClassData () {
      const res = await this.$axios.post("/base/class/list")
      if (res.status == 200 && res.data.errCode == 0) {
        // console.log(res.data.data)
        if (res.data.data.length == 0) {
          // alert(res.data.data)
          // alert(123);
          // this.$refs.cutdialog.innerVisible1 = true;
          this.$refs.cutdialog.dialogVisible = true
        }
      } else {
        this.$message.error(res.data.message)
      }
    },
    getNowHeight () {
      // this.$refs.aside.style.Height = this.nowHeight+'px'
      // 获取屏幕可视区域高度
      this.nowHeight = (document.documentElement.clientHeight + 20) + "px"
    },
    getUrl () {
      let self = this
      let currentUrl = window.location.href
      self.currentMenu = currentUrl.split("#")[1]
    },
    handleOpen (key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClose (key, keyPath) {
      // console.log(key, keyPath);
    },
    exitFlags () {
      if (this.exitFlag == false) {
        this.exitFlag = true
      } else {
        this.exitFlag = false
      }
    },
    cut_class () {
      this.$refs.cutdialog.dialogVisible = true
      this.$refs.cutdialog.cutClassData()
      // console.log(123)
    },
    baseData () {
      this.name = window.localStorage.getItem("name")
      this.photo = window.localStorage.getItem("photo")
      this.username = window.localStorage.getItem("name") || window.localStorage.getItem("username") || ''
      if (window.localStorage.getItem("class_name") == 'undefined') {
        this.class_name = ""
        this.course_name = ""
      } else {
        this.class_name = window.localStorage.getItem("class_name")
        this.course_name = window.localStorage.getItem("course_name")
      }
    },
    toMenu (item) {
      this.menuId = item.id
      this.$router.push(item.path)
    },
    nowRoute () {
      // console.log(this.$route.path.substr(0,7))
      for (let i = 0; i < this.menuList.length; i++) {
        if (
          this.$route.path == this.menuList[i] &&
          this.$route.path.substr(0, 7) == this.menuList[i]
        ) {
          this.activeIndex = menuList[i].id
          break
        }
      }
    },
    //退出
    handleCommand (command) {
      if (command === 'modify') {
        console.log("修改密码")
        this.isChangePassword = true
      } else if (command === 'exit') {
        window.localStorage.clear()
        window.sessionStorage.clear()
        this.$router.push("/")
      }
    },
    closePass () {
      this.isChangePassword = false
    },
    async savePass (form) {
      console.log("新旧密码：", form)
      const { data: res } = await this.$axios.post('/base/user/modify/pwd', form)
      if (res.errCode === 0) {
        this.isChangePassword = false
        this.$message.success(res.message)
      } else {
        this.$message.error(res.message)
      }
    },

    // 获取系统信息
    async getSystemInfo () {
      const { data: res } = await this.$axios.get('/public/system/info')
      this.versions = res.data
    },

    // 获取班级课程名称
    returnCourseName () {
      // classInfo.course_name
      if (this.classInfo && this.classInfo.course_name) {
        return `(${this.classInfo.course_name})`
      } else {
        return ''
      }
    },
  },

}
</script>

<style lang="scss" scoped>
.index {
  height: 918px;
}

.version-footer {
  height: 40px !important;
  line-height: 40px;
  font-size: 14px;
  color: #b3c0d1;
  background: #fff;
}

/deep/ .el-button--primary {
  background-color: #2881cd;
  border-color: #2881cd;
}

/deep/ .el-button--warning {
  background-color: #da6013;
  border-color: #da6013;
}

// /deep/ .el-button--danger {
//   background-color: #fff;
//   border-color: #fff;
// }

/deep/ .el-input__inner {
  border: 1px solid #92b7d6;
}

/deep/ .el-select__caret {
  color: #2881cd;
  font-weight: bolder;
}

.el-container {
  background: #2881cd;
  // width: 600px;
  // width: 100%;
}

/deep/ .el-pagination {
  // position: absolute;
  // bottom: 10px;
  // margin: auto;
  // left: 0;
  // right: 0;
  text-align: center;
  // margin-left: -256px;
}

/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #2881cd;
}

/deep/ .el-menu-vertical-demo {
  background: #2881cd;
}

// 左侧菜单栏
.aside {
  ul {
    text-align: center;

    li {
      border-radius: 8px;
      margin: auto;
      width: 140px;
      height: 48px;
      // background-color: rgba(219, 231, 255, 0.79);
      // border-radius: 6px;loginInfo
      // opacity: 0.6;
      line-height: 48px;
      margin-top: 20px;
      font-size: 16px;
      font-weight: normal;
      color: #ffffff;
    }
  }

  ul>li:hover {
    background-color: rgba(219, 231, 255, 0.79);
    border-radius: 6px;
    opacity: 0.6;
    cursor: pointer;
  }

  ul>li:visited {
    color: red;
    background-color: rgba(219, 231, 255, 0.79);
    border-radius: 6px;
    opacity: 0.6;
    cursor: pointer;
  }

  /deep/ .el-menu-item.is-active {
    background-color: rgba(219, 231, 255, 0.79);
    border-radius: 8px;
  }
}



.flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/deep/.el-main {
  scrollbar-width: none;
  /* firefox */
  -ms-overflow-style: none;
  /* IE 10+ */
  overflow-x: hidden;
  overflow-y: auto;
  height: 856px;
}

.el-header {
  padding: 0 60px;
  // width: 1770px !important;
  height: 50px !important;
  background: #fff;

  position: relative;
  width: 100%;
  height: 100px !important;
  // background-color: #2881cd;
  text-align: left;
  display: flex;
  // align-items: flex-end;
  // box-shadow: 3px 3px 7px 0px rgba(40, 129, 205, 0.33);
  // background: url("../../assets/header/head.png");
  background-size: 100;

  >div {
    width: 100%;

    .qiehuanClass {
      width: 350px;
      line-height: 80px;
      /* 2025.6.9 更新 */
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      /* 2025.6.9 更新 */
      float: left;
      margin-right: 10%;
      // position: relative;
      display: flex;
      justify-content: center;

      img {
        display: inline-block;
        width: 16px;
        height: 16px;
        margin-top: 33px;
        margin-left: 10px;
        margin-right: 10px;
        line-height: 80px;
      }

      img:hover {
        cursor: pointer;
      }
    }

    .titles {
      line-height: 80px;
      // float: left;
      text-align: left;
      width: 180px;
      height: 31px;
      font-size: 24px;
      font-weight: normal;
      // line-height: 31px;
      // letter-spacing: 0px;
      color: #1b2422;
    }

    // .lasts {
    // float: right;
    // width: 200px !important;
    // text-align: right;
    // position: relative;
    // line-height: 80px;

    // ul {
    //   width: 200px !important;
    // }

    // i:hover {
    //   cursor: pointer;
    // }

    // >div {
    //   border-radius: 12px;
    // }

    // img {
    //   position: absolute;
    //   margin-left: -50px;
    //   top: 23px;
    //   border-radius: 50%;
    //   width: 36px;
    //   height: 36px;
    //   display: inline-block;
    //   // line-height: 100px;
    // }
    // }
  }

  img {
    width: 48px;
    height: 48px;
    display: inline-block;
    // line-height: 100px;
  }

  span {
    margin-left: 18px;
    margin-right: 40px;
    margin-top: 55px;
    // line-height: 100px;
    font-size: 36px;
    color: #ffffff;
  }

  // 退出的下拉菜单
  .el-dropdown {
    top: 20px;
    cursor: pointer;

    .el-dropdown-link img {
      width: 38px;
      height: 38px;
      vertical-align: text-bottom;
      cursor: pointer;
    }

    .el-dropdown-menu {
      margin-top: 20px;
    }
  }
}

.el-popper[x-placement^="bottom"] {
  margin-top: -28px;
}

// .el-header {
//   // background-color: #b3c0d1;
//   color: #333;
//   text-align: center;
//   line-height: 60px;
// }

.el-aside {
  overflow: hidden;
  // height: 100%;
  background-color: #2881cd;
  // color: #333;
  text-align: center;

  // line-height: 200px;
  img {
    margin-top: 23px;
    margin-bottom: 6px;
  }
}

.el-main {
  background-color: #fff;
  color: #333;
  text-align: left;
  // height: 820px;
  padding-top: 0;
  /* line-height: 160px; */
  // width: 100%;
  // width: 166px;
}

/deep/ .el-header span {
  // margin-left: 0px;
  font-size: 16px;
}

.trigon {
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid #fff;
}

/deep/ .el-dialog__header {
  border-bottom: 1px solid #f1f4f6;
  text-align: center;
}

/deep/ .el-menu-vertical-demo {
  width: 100%;
}

/deep/ .el-empty {
  margin-top: 10%;
  margin-left: -200px;
}

// /deep/ .el-dropdown-link {
//   line-height: 80px !important;
// }

.zong {
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/view/Panel/index.vue